import { render } from "./GroupServicesSlide.vue?vue&type=template&id=19e13e38"
import script from "./GroupServicesSlide.vue?vue&type=script&lang=js"
export * from "./GroupServicesSlide.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/nuxt-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__